import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'

import MaintenanceWrapper from 'components/MaintenanceWrapper/MaintenanceWrapper'
import injectTranslate from 'i18n/hoc/injectTranslate'
import MenuLink from 'layouts/components/MenuLink'
import { fromContext, fromFirm, fromPro } from 'store/selectors'
import PageTemplate from 'templates/PageTemplate'
import { theme, breakpointMax } from 'utils/style'
import proTabs from 'utils/pro/proTabs'
import HeaderSectionContainer from 'sections/HeaderSection/HeaderSectionContainer'
import FooterSection from 'sections/FooterSection/FooterSection'

const DeployMenuLink = styled(MenuLink)`
  ${breakpointMax('l')`
    padding: ${theme('spaces.m')};
    width: 100%;
  `}
`

const DeployMenuNoLink = styled.span`
  ${breakpointMax('l')`
    padding: ${theme('spaces.m')};
    width: 100%;
  `}
`

const MobileNavItem = ({ tab, children }) => {
  if (!tab) {
    return (
      <li>
        <DeployMenuNoLink>{children}</DeployMenuNoLink>
      </li>
    )
  }

  return (
    <li>
      <DeployMenuLink forceReload={tab.forceRedirect} to={tab.to}>
        {children}
      </DeployMenuLink>
    </li>
  )
}

MobileNavItem.propTypes = {
  tab: PropTypes.shape({
    to: PropTypes.string,
    forceRedirect: PropTypes.bool,
  }),
  children: PropTypes.node.isRequired,
}

// eslint-disable-next-line no-unused-vars
const ProLayout = ({ children, locale, translate, isLoggedIn, tabs }) => (
  <MaintenanceWrapper>
    <PageTemplate
      header={<HeaderSectionContainer layout="pro" />}
      footer={<FooterSection />}
      noBackground
      locale={locale}
    >
      {children}
    </PageTemplate>
  </MaintenanceWrapper>
)

ProLayout.propTypes = {
  children: PropTypes.node,
  locale: PropTypes.string,
  translate: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  tabs: PropTypes.object,
}

export default compose(
  connect(state => ({
    locale: fromContext.getLocale(state),
    language: fromContext.getLang(state),
    isLoggedIn: fromPro.isLoggedIn(state),
    tabs: proTabs(
      fromContext.getLocale(state),
      fromFirm.getDetails(state, fromPro.getFirmId(state)),
      fromContext.getLang(state),
    ),
  })),
  injectTranslate,
)(ProLayout)
